module Elma.Bindings {

    export interface IRefreshCheckout {
        containerTarget?: string,
        pageURL?: string,
        checkoutStep?: number
    }

    export class RefreshCheckout {

        // refresh page with ajax
        // update custom html container (class or id) with new html

        private updateValues = (element: HTMLFormElement, valueAccessor: () => IRefreshCheckout, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) => {

            if (!bindingContext) {
                return;
            }

            const value = ko.unwrap(valueAccessor());
            const $elm = $(element);
            let targetURL = $elm.attr("action") + "&LayoutTemplate=ajax_page.cshtml";
            if (value.checkoutStep){
                targetURL += "&CartV2.GotoStep" + value.checkoutStep + "=true";
            }
            const containerTarget = typeof value.containerTarget != "undefined"
                ? value.containerTarget : ".js-ajax-checkout"; // default value js-ajax-checkout
            const logger = Ftw.Base.Config.Logger;


            if (targetURL) {
                
                $elm.on("ajaxSubmit", function (e) {

                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (typeof bindingContext.$data.loadedChosenShipping() != "undefined") {
                        $.ajax({
                            url: targetURL,
                            data: $elm.serialize() + "&EcomCartShippingmethodID="+ bindingContext.$data.loadedChosenShipping(),
                            type: "POST",
                            dataType: "html", 
                            success: function loadAchieved(data, status, jqXHR) {
                                if (data) {
                                    var $updatedContainer = $(data).find(containerTarget);
                                    if ($updatedContainer.length) {
                                        $(containerTarget).html($updatedContainer.html());
                                    }
                                }
                            }
                        });
                    }
                    else {
                        logger.warning("no shipping methods present");
                    }

                    return false;

                });
            }


        };

        public init = this.updateValues;
        public update = this.updateValues;

    }

    ko.bindingHandlers['refreshCheckout'] = new RefreshCheckout();

}